// Vendor
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
// Selectors
import { getCurrentWizardStepIndex, getPrimarySecurity, getSavedAnalysisPlanId, getWizardStepEventName, } from '../../state/selectors';
// Services
import { SavedAnalysisPlanService } from 'HypotheticalsApp/services/saved-analysis-plan.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
// Actions
import { decrementCurrentWizardStep, incrementCurrentWizardStep } from '../../state/wizard-step/wizard-step.actions';
import { setSavedAnalysisPlanId } from '../../state/saved-analysis-plan-id/saved-analysis-plan-id.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
// Reducers
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from '../../state/reducer';
// Components
import { OpenItemTabsComponent } from 'NewAngular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component';
import { resetPrimarySecurity, resetSecondarySecurity, setPrimarySecurity, setSecondarySecurity, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-securities/report-securities.actions';
import { MODEL_PORTFOLIO } from 'NewAngular/constants/core.constants';
import * as i0 from "@angular/core";
import * as i1 from "HypotheticalsApp/services/saved-analysis-plan.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "NewAngular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component";
const _c0 = ["openItemTabsComponent"];
function ReportAnalysisPlanSelectorModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function ReportAnalysisPlanSelectorModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function ReportAnalysisPlanSelectorModalComponent_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); });
    i0.ɵɵtext(1, "Back ");
    i0.ɵɵelementEnd();
} }
export class ReportAnalysisPlanSelectorModalComponent {
    constructor(savedAnalysisPlanService, securitiesService, store) {
        this.savedAnalysisPlanService = savedAnalysisPlanService;
        this.securitiesService = securitiesService;
        this.store = store;
        // Outputs
        this.broadcastWizardStepEvent = new EventEmitter();
        // Data & flags
        this.savedAnalysisPlans = [];
        this.sharedSavedAnalysisPlans = [];
        this.isOpen = false;
        this.forwardDisabled = true;
        this.currentWizardStepIndex = null;
        this.selectedAnalysisPlanId = null;
        this.savedItemType = SavedItemType.ANALYSIS_PLAN;
        this.errorMessage = '';
        this.mandatoryPrimarySecurity = null;
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.selectedAnalysisPlanId = getSavedAnalysisPlanId(state);
            const primarySecurity = getPrimarySecurity(state);
            if (primarySecurity.securityId === null || primarySecurity.isMandatory) {
                this.mandatoryPrimarySecurity = primarySecurity.securityId;
            }
            if (!this.isOpen &&
                this.currentWizardStepIndex === 0 &&
                getWizardStepEventName(state) === CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL) {
                this.openModal();
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        if (this.storeSubscription)
            this.storeSubscription.unsubscribe();
    }
    selectAnalysisPlan(itemAndAction) {
        const selectedAnalysisPlan = itemAndAction.item;
        this.forwardDisabled = false;
        this.selectedAnalysisPlanId = itemAndAction.item ? Number(itemAndAction.item.id) : null;
        this.store.dispatch(setSavedAnalysisPlanId({ savedAnalysisPlanId: this.selectedAnalysisPlanId }));
        const securityId = selectedAnalysisPlan?.state?.securityId;
        if (securityId) {
            if (this.mandatoryPrimarySecurity === null) {
                this.securitiesService.getSecuritiesInfo(securityId).subscribe((securitiesInfo) => {
                    if (securitiesInfo.length > 0) {
                        const [securityInfo] = securitiesInfo;
                        this.store.dispatch(setPrimarySecurity({
                            securityId: securityInfo.security_id,
                            securityName: securityInfo.security_name,
                            displaySecurityID: securityInfo.display_security_id,
                            securityType: MODEL_PORTFOLIO,
                            disableEditBtn: true,
                        }));
                    }
                });
            }
        }
        else {
            this.store.dispatch(resetPrimarySecurity());
        }
        const comparableId = selectedAnalysisPlan?.state?.comparableId;
        if (comparableId) {
            this.securitiesService.getSecuritiesInfo(comparableId).subscribe((securitiesInfo) => {
                if (securitiesInfo.length > 0) {
                    const [securityInfo] = securitiesInfo;
                    this.store.dispatch(setSecondarySecurity({
                        securityId: securityInfo.security_id,
                        securityName: securityInfo.security_name,
                        displaySecurityID: securityInfo.display_security_id,
                        securityType: MODEL_PORTFOLIO,
                        disableEditBtn: true,
                    }));
                }
            });
        }
        else {
            this.store.dispatch(resetSecondarySecurity());
        }
    }
    closeModal() {
        this.isOpen = false;
    }
    openModal() {
        this.isOpen = true;
        // Refresh the savedHypotheticals list in case new items were added
        this.savedAnalysisPlanService.getItems().subscribe({
            next: (response) => {
                const filteredAnalysisPlans = this.mandatoryPrimarySecurity === null
                    ? response.plans
                    : response.plans.filter((p) => p.state.securityId === this.mandatoryPrimarySecurity);
                this.savedAnalysisPlans = filteredAnalysisPlans.filter((plan) => plan.sharing?.is_owner || true);
                this.sharedSavedAnalysisPlans = filteredAnalysisPlans.filter((plan) => !plan.sharing?.is_owner || false);
                this.errorMessage =
                    filteredAnalysisPlans.length !== 0
                        ? ''
                        : 'No Interactive Analysis Plans are available because no plans have been saved with this security as the primary security.';
            },
            error: () => {
                this.savedAnalysisPlans = [];
                this.sharedSavedAnalysisPlans = [];
                this.errorMessage = 'There was an error loading analysis plan. Please try again or contact support.';
            },
        });
        if (this.selectedAnalysisPlanId === null) {
            this.forwardDisabled = true;
            this.openItemTabsComponent.clearSelection();
            this.store.dispatch(setSavedAnalysisPlanId({ savedAnalysisPlanId: null }));
            this.store.dispatch(resetPrimarySecurity());
            this.store.dispatch(resetSecondarySecurity());
        }
    }
    back() {
        this.closeModal();
        this.store.dispatch(setSavedAnalysisPlanId({ savedAnalysisPlanId: null }));
        this.store.dispatch(resetPrimarySecurity());
        this.store.dispatch(resetSecondarySecurity());
        if (this.currentWizardStepIndex) {
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
        else {
            this.store.dispatch(resetAllCustomPdfReportItems());
        }
    }
    forward() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
}
ReportAnalysisPlanSelectorModalComponent.ɵfac = function ReportAnalysisPlanSelectorModalComponent_Factory(t) { return new (t || ReportAnalysisPlanSelectorModalComponent)(i0.ɵɵdirectiveInject(i1.SavedAnalysisPlanService), i0.ɵɵdirectiveInject(i2.SecuritiesService), i0.ɵɵdirectiveInject(i3.Store)); };
ReportAnalysisPlanSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportAnalysisPlanSelectorModalComponent, selectors: [["ycn-report-analysis-plan-selector-modal"]], viewQuery: function ReportAnalysisPlanSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.openItemTabsComponent = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, decls: 13, vars: 13, consts: [["openItemTabsComponent", ""], [3, "closeModalHandler", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "doActionOnItemHandler", "ownItems", "sharedItems", "sharedWithMeEnabled", "selectOnly", "savedItemType", "showRadioButtons"], [1, "modal-footer"], [1, "modal-footer-info"], ["class", "text-red", 3, "textContent", 4, "ngIf"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["data-test-id", "submit-scenario-report-securities", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "innerText"], [1, "text-red", 3, "textContent"], [1, "btn", "btn-secondary", 3, "click"]], template: function ReportAnalysisPlanSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ReportAnalysisPlanSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ReportAnalysisPlanSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "ycn-open-item-tabs", 4, 0);
        i0.ɵɵlistener("doActionOnItemHandler", function ReportAnalysisPlanSelectorModalComponent_Template_ycn_open_item_tabs_doActionOnItemHandler_3_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectAnalysisPlan($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, ReportAnalysisPlanSelectorModalComponent_div_7_Template, 1, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
        i0.ɵɵlistener("click", function ReportAnalysisPlanSelectorModalComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(10, "Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, ReportAnalysisPlanSelectorModalComponent_div_11_Template, 2, 0, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵlistener("click", function ReportAnalysisPlanSelectorModalComponent_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen)("extraModalClasses", "modal-no-border");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Interactive Analysis Plan");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ownItems", ctx.savedAnalysisPlans)("sharedItems", ctx.sharedSavedAnalysisPlans)("sharedWithMeEnabled", true)("selectOnly", true)("savedItemType", ctx.savedItemType)("showRadioButtons", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex != 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.forwardDisabled)("innerText", "Next");
    } }, dependencies: [i4.NgIf, i5.DisabledDirective, i6.ModalBaseComponent, i7.SimpleModalHeaderComponent, i8.OpenItemTabsComponent], encapsulation: 2 });
